export const landingConfig = {
  apiBaseUrl: (import.meta.env.VITE_API_URL || "").replace(/\/$/, ""),
  analytics: {
    ga4MeasurementId: import.meta.env.VITE_GA4_MEASUREMENT_ID || "",
    googleAdsId: import.meta.env.VITE_GOOGLE_ADS_ID || "",
    googleAdsLeadLabel: import.meta.env.VITE_GOOGLE_ADS_LEAD_LABEL || "",
    metaPixelId: import.meta.env.VITE_META_PIXEL_ID || "",
  },
};
